"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemComponent = exports.MenuItemWrapperComponent = void 0;
var mithril_1 = require("../../mithril");
var index_1 = require("../icon/index");
var theme_1 = require("../theme");
var menu_item_style_1 = require("./menu.item.style");
(0, theme_1.addStyles)(menu_item_style_1.Style);
exports.MenuItemWrapperComponent = {
    view: function (menu, item, selected) {
        var onclick = undefined;
        if (!item.disabled && item.action != null) {
            onclick = function () {
                menu.hide();
                item.action();
            };
        }
        return (0, mithril_1.m)('div', {
            className: "".concat(menu_item_style_1.CSS.item, " ").concat(item.visible === false ? menu_item_style_1.CSS.hidden : '', " ").concat(selected ? menu_item_style_1.CSS.selected : '', " ").concat(item.disabled ? menu_item_style_1.CSS.disabled : ''),
            onmouseenter: function () { return menu.selectItem(item); },
            onclick: onclick
        }, item.view);
    }
};
exports.MenuItemComponent = {
    view: function (text, icon) {
        return mithril_1.m.fragment({}, [].concat(icon != null ? index_1.Icon.view(icon) : null, text));
    }
};
//# sourceMappingURL=menu.item.js.map